import { CgHeadset } from "react-icons/cg";
import { Tag } from "antd";
import { pathOr } from "lib/functions";
import React from "react";

export const OfficeTypeTag = ({ office }) => {
	const { online, options } = office;
	const optionsExists = pathOr(
		false,
		["options", "reservations", "attention_type"],
		office
	);

	return (
		<>
			{optionsExists ? (
				[
					[
						"#F4FDDD",
						"#5B8C00",
						"Presencial y videollamada",
						optionsExists === "mixed",
						CgHeadset,
					],
					[
						"#FBEAFF",
						"#A157B0",
						"Videollamada",
						optionsExists === "videocall",
						CgHeadset,
					],
					[
						"#E6F7FF",
						"#91D5FF",
						"Presencial",
						optionsExists === "face-to-face",
						CgHeadset,
					],
					[
						"#FBEAFF",
						"#A157B0",
						"Videollamada",
						optionsExists === "meet",
						CgHeadset,
					],
					[
						"#E6F7FF",
						"#91D5FF",
						"Presencial",
						optionsExists === "face2face",
						CgHeadset,
					],
				].map(([bgColor, color, label, show, Icon]) =>
					show ? (
						<span>
							<Tag
								style={{
									display: "flex",
									alignItems: "center",
									borderColor: color,
									color,
								}}
								color={bgColor}
							>
								<Icon
									style={{ fontSize: 16, marginRight: 5 }}
								/>
								Atención: {label}
							</Tag>
						</span>
					) : null
				)
			) : (
				<span>
					<Tag
						style={{
							display: "flex",
							alignItems: "center",
							borderColor: "#91D5FF",
							color: "#91D5FF",
						}}
						color={"#E6F7FF"}
					>
						<CgHeadset style={{ fontSize: 16, marginRight: 5 }} />
						{"Atención: Presencial"}
					</Tag>
				</span>
			)}
		</>
	);
};
